export default function formatPercentage(value: number, skipUnit?: boolean) {
  return skipUnit ? `${value * 100}` : `${value * 100}%`;
}
